"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRegister = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var register_1 = require("../../model/register");
var service_1 = require("../../../library/base/service");
var UserRegister = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UserRegister, _super);
    function UserRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '注册账号接口';
        _this.code = '101082';
        _this.desc = '注册账号接口';
        _this.requestParams = new register_1.UserRegisterRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UserRegister;
}(service_1.BaseService));
exports.UserRegister = UserRegister;
//# sourceMappingURL=userRegister.js.map